import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const paymentSettingsManage: IMcAppType = {
  name: "paymentSettingsManage",
  path: "/my/payment-settings",
  description: "Manage Payment Settings",
  navFlow: NavFlow.STANDARD,
  title: "Payment settings",
  parent: Tab.DASHBOARD, // Changed from Tab.MORE, Temporary workaround due to navigation issues on Mobile. See https://origindd.atlassian.net/browse/P21-2410

  conditions: {
    intent: "paymentSettingsManage",
    customerType: CustomerType.kraken,
  },
};
